import {Link} from 'react-router-dom';

// const userData = JSON.parse(localStorage.getItem('user') || 'null');
// const userId = userData?.profile?.guid;

export const publicFaqs = [
  {
    title: 'فروشگاه مزرعه چه اهدافی دارد؟',
    body: 'هدف فروشگاه مزرعه ایجاد بستری اختصاصی برای همرسانی عرضه و تقاضای کود، سم، بذر، ابزار و خدمات مشاوره و آزمایشگاهی حوزه کشاورزی است. ',
  },
  {
    title: 'چطور می‌توانم با شما ا‌رتباط مستقیم داشته باشم؟',
    body: 'میتوانید با شمارههای 09352593515 ، 09352593517 و 09352593556 در پیام رسان بله، واتساپ، تلگرام، ایتا و روبیکا بصورت 24 ساعته و با شماره 02166402031 و 02166401773 در ساعات اداری تماس بگیرید.',
  },
  {
    title: 'خدمات فروشگاه مزرعه شامل چه بخشهایی است؟',
    body: 'در فروشگاه مزرعه امکاناتات متعددی مانند ثبت فروشگاه و ثبت آگهی، ثبت شبکه توزیع و عاملین فروش، درج استوری و بنر برای برندسازی و استفاده از ابزارهای تبلیغاتی متعدد مانند موتور جستجوی هوشمند، ارسال هدفمند (Segmentation) پیامک و ایمیل برای کشاورزان و تامین کنندگان وجود دارد.',
  },
  {
    title: 'فروشگاه مزرعه چه مزیتهایی نسبت به سایر فروشگاههای کشاورزی دارد؟',
    body: 'اپلکیشن مزرعه یک پروتکل دیتاست و مستقل از کشاورز و فروشندگان کالاو خدمات کشاورزی، یک جریان داده قابل اعتماد برای خرید یا فروش نهاده و خدمات کشاورزی در اختیار استفادهکنندگان از این اپلکیشن قرار میدهد.',
  },
  {
    title: 'چطور میتوانم یک فروشگاه ثبت کنم؟',
    body: 'بعد از ورود به اپلکیشن فروشگاه میتوانید با بارگذاری مدارک و مجوز کسب و کار خود و تکمیل اطلاعات درخواست شده یک صفحه فروشگاه اختصاصی ثبت کنید. کارشناسان مزرعه بعد از بررسی مدارک شما، در اولین فرصت صفحه فروشگاهی شما در مزرعه را فعال میکنند.',
  },
  {
    title: 'منظور از عاملین فروش چیست؟',
    body: 'عاملین فروش شامل فروشندگان یا نمایندگیها و شعبه های فروش شما در شهرها و مناطق مختلف است.',
  },
  {
    title: 'تا چه تاریخی میتوانم از خدمات فروشگاه بصورت رایگان استفاده کنم؟',
    body: 'خدمات پایه فروشگاه مانند ثبت فروشگاه، ثبت آگهی و تماس با کشاورزان برای همیشه بصورت رایگان در اختیار شما قرار دارد. با این وجود، خدمات رایگان محدودیتهایی در حوزه تبلیغات و فروش کالا و خدمات دارد. با تهیه اشتراک فروشگاه میتوانید از همه ابزارهای تبلیغاتی و همرسانی مزرعه در راستای جهش فروش خود استفاده کنید.',
  },
  {
    title:
      'فروشگاه مزرعه برای توزیع کنندگان که نمایندگی و عامل فروش دارند به چه صورت عمل میکند؟',
    body: 'با ثبت شبکه توزیع و عاملین فروش خود در فروشگاه، کشاورزان از هر نقطهای در کشور میتوانند با نزدیکترین عامل فروش شما در آن منطقه تماس بگیرند و خدمات یا کالاهای شما را خریداری کنند. قابل ذکر است که هر کاربر حداکثر میتواند آدرس و اطلاعات تماس پنج عامل فروش نزدیک به خود را دریافت کند.',
  },
  {
    title:
      'آیا امکان اتصال فروشگاه سامانه مزرعه به سایت فروشگاه شخصی وجود دارد؟',
    body: 'بله این امکان به طور مستقیم از طریق درج استوری و بنر در صفحه نخست فروشگاه و صفحات دیگر سامانه مزرعه وجود دارد. ',
  },
  {
    title: 'چطور میتوانم بازدید آگهی فروشگاهم را بیشتر کنم؟',
    body: (
      <>
        شما میتوانید در قسمت "{<Link to="/my-account">حساب من</Link>}" در بخش "
        {<Link to="/my-ads">آگهی من</Link>}" آگهی خود را مدیریت کرده و از
        ابزارهای مختلف "ارتقا آگهی" مانند متمایزسازی و پیشتازسازی استفاده کنید.
        همه این ابزارهای با تهیه اشتراک فروشگاه مزرعه در قسمت "
        {<Link to="/my-store-info">فروشگاه من</Link>}" بصورت خودکار برای شما
        فعال میشود.
      </>
    ),
  },
  {
    title: 'آیا فروشگاه سامانه مزرعه وابسته به نهادهای دولتی یا عمومی است؟',
    body: 'سامانه مزرعه یک استارت آپ خصوصی زیرمجموعه شرکت آینده پژوهان لوتوس است و به نهاد دولتی یا عمومی دیگری وابسته نیست. همه اطلاعات کاربران در این اپلکیشن، با قرارداد محرمانگی اطلاعات توافق شده در زمان ثبتنام پشتیبانی میشود. شرکت آینده پژوهان لوتوس موظف است هرگونه تغییر در این قرارداد را به اطلاعات کاربران برساند.',
  },
];
